export default __webpack_public_path__ + "static/media/NeptuneDb.e9d1b816.svg";